module.exports = __webpack_public_path__ + "static/media/KatherineMoss2.eaf474dc.svg";